class FindInStorePanel extends HTMLElement {
  connectedCallback () {
    this.panel = document.getElementById('find-in-store-panel');
    this.panelOverlay = document.getElementById('find-in-store-panel-overlay');
    this.body = document.querySelector('body');
    this.findInStoreButtons = document.querySelectorAll('[data-find-in-store]');
    this.onBodyClick = this.handleBodyClick.bind(this);
    this.storeInfoPage = this.dataset.storeInfoPage
    this.sizeSelector = document.getElementById('store-availability-size');
    this.variantRadios = document.querySelectorAll('input[name="Size"]');
    this.activeElement = null;

    if (!this.panel) return;

    this.panel.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    
    this.panel.addEventListener('click', (e) => {
      if (e.target && e.target.classList.contains('find-in-store-panel__close')) {
        this.close();
      }
    });

    
    this.findInStoreButtons.forEach((button) => {
      button.addEventListener('click', this.open.bind(this));
    });

    document.addEventListener('jtcVariantLocationsLoaded', (e) => {
      this.locations = e.detail.locations;
      this.renderStores(e.detail.variantID);
    });

    this.sizeSelector.addEventListener('change', () => {
      this.variantRadios.forEach(radio => {
        if (radio.value === this.sizeSelector.selectedOptions[0].textContent) {
          radio.nextElementSibling.click(); // Click the label to simulate a user interaction
        }
      });
    });
  }

  open(event) {
    if (event) {
      event.preventDefault();
      this.activeElement = event.target;
    }

    this.classList.remove('tw-hidden');

    this.calcPositionOfPanel();
    this.panel.classList.add('active');
    if (this.panelOverlay) {
      this.panelOverlay.classList.add('active');
      requestAnimationFrame(() => { // prevents immediate closing
        this.body.addEventListener('click', this.onBodyClick);
      });
    }

    this.panel.addEventListener('transitionend', () => {
      this.panel.focus();
      if (typeof trapFocus === 'function') {
        trapFocus(this.panel);
      }
    }, { once: true });

    if (typeof enableScrollLock === 'function') {
      requestAnimationFrame(() => {
        enableScrollLock(this);
      });
    } else {
      this.body.classList.add('tw-overflow-hidden');
    }
  }

  close() {
    this.classList.add('tw-hidden');
    this.panel.classList.remove('active');
    if (this.panelOverlay) {
      this.panelOverlay.classList.remove('active');
      this.body.removeEventListener('click', this.onBodyClick);
    }

    if (typeof removeTrapFocus === 'function') {
      removeTrapFocus(this.activeElement);
    }

    if (typeof disableScrollLock === 'function') {
      disableScrollLock(this);
    } else {
      this.body.classList.remove('tw-overflow-hidden');
    }
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if ((evt.isTrusted && !evt.target instanceof HTMLInputElement) && target !== this.panel &&!target.closest('find-in-store-panel') || target === this.panelOverlay) {
      this.activeElement = target.closest('button');
      this.close();
    }
  }

  calcPositionOfPanel() {
    if (!this.panel) {
      return;
    }

    const stickyHeader = document.querySelector('sticky-header');

    if (window.innerWidth >= 1280 && !this.announcementBarIsOnScreen) {
      this.resetPosition();
      return;
    }

    if (window.innerWidth >= 1280) {
      this.positionBelowAnnouncementBar();
      return;
    }

    if (window.innerWidth < 768) {
      this.resetPosition();
      return;
    }

    if (stickyHeader) {
      this.positionBelowStickyHeader();
    }
  }

  resetPosition() {
    if (this.panel) {
      this.panel.parentElement.style.removeProperty('top');
      this.panel.parentElement.style.removeProperty('height');
    }
    if (this.panelOverlay) {
      this.panelOverlay.style.removeProperty('top');
      this.panelOverlay.style.removeProperty('height');
    }
  }

  positionBelowStickyHeader() {
    const stickyHeader = document.querySelector('sticky-header');
    if (!stickyHeader) return;

    const stickyHeaderBounds = stickyHeader.getBoundingClientRect();
    const topPosition = stickyHeaderBounds.bottom + 'px';
    const height = `calc(100vh - ${stickyHeaderBounds.bottom}px)`;

    if (this.panel) {
      this.panel.parentElement.style.setProperty('top', topPosition, 'important');
      this.panel.parentElement.style.setProperty('height', height, 'important');
    }
    if (this.panelOverlay) {
      this.panelOverlay.style.setProperty('top', topPosition, 'important');
      this.panelOverlay.style.setProperty('height', height, 'important');
    }
  }

  positionBelowAnnouncementBar() {
    const announcementBar = document.getElementById('announcement-bar-wrapper');
    if (!announcementBar) return;

    const announcementBarBounds = announcementBar.getBoundingClientRect();
    const topPosition = announcementBarBounds.bottom + 'px';
    const height = `calc(100vh - ${announcementBarBounds.bottom}px)`;

    if (this.panel) {
      this.panel.parentElement.style.setProperty('top', topPosition, 'important');
      this.panel.parentElement.style.setProperty('height', height, 'important');
    }
    if (this.panelOverlay) {
      this.panelOverlay.style.setProperty('top', topPosition, 'important');
      this.panelOverlay.style.setProperty('height', height, 'important');
    }
  }

  get announcementBarIsOnScreen() {
    return this.announcementBarVisibleHeight > 0;
  }

  get announcementBarVisibleHeight() {
    const announcementBar = document.getElementById('announcement-bar-wrapper');
    return announcementBar && this._calcVisibleHeight(announcementBar);
  }

  _calcVisibleHeight(element) {
    const elementRect = element.getBoundingClientRect();
    const windowHeight = window.innerHeight || document.documentElement.clientHeight;
    const visibleHeight = Math.max(0, Math.min(elementRect.bottom, windowHeight) - Math.max(elementRect.top, 0));
    return visibleHeight;
  }

  loadStoreData() {
    const storesList = document.getElementById('find-in-store-stores-list');
    if (!storesList) return;

    storesList.innerHTML = '<div class="find-in-store-panel__loading | tw-text-center | tw-py-8"><p class="tw-type-style-5 | tw-text-primary_mid_grey | tw-m-0">Loading store information...</p></div>';

    setTimeout(() => {
      this.renderStores([]);
    }, 500);
  }

  getProductId() {
    const productForm = document.getElementById('product-form-' + this.getSectionId());
    if (!productForm) return null;
    
    const productIdInput = productForm.querySelector('input[name="id"]');
    return productIdInput ? productIdInput.value : null;
  }

  getVariantId() {
    const productForm = document.getElementById('product-form-' + this.getSectionId());
    if (!productForm) return null;
    
    const variantIdInput = productForm.querySelector('input[name="id"]');
    return variantIdInput ? variantIdInput.value : null;
  }

  getSectionId() {
    const section = document.querySelector('[id^="ProductInfo-"]');
    if (!section) return '';
    return section.id.replace('ProductInfo-', '');
  }

  renderStores(variantID = '') {
    const storesList = document.getElementById('find-in-store-stores-list');
    if (!storesList) return;

    if (this.locations.length === 0) {
      storesList.innerHTML = '<div class="find-in-store-panel__loading | tw-text-center | tw-py-8"><p class="tw-type-style-5 | tw-text-primary_mid_grey | tw-m-0">No stores found with this product in stock.</p></div>';
      return;
    }

    if (variantID !== '') {
      document.getElementById('store-availability-size').value = variantID;
    }

    storesList.innerHTML = '';

    console.log(this.locations);
    this.locations.forEach(location => {
      if (!location.enabled) return;
      let templateNode = document.importNode(document.getElementById('find-a-store-item').content, true)?.children[0];
      templateNode.querySelector('.find-in-store-panel__store-name').textContent = location.name;
      templateNode.querySelector('.find-in-store-panel__size').textContent = `Size: ${document.getElementById('store-availability-size').selectedOptions[0].textContent}`;
      templateNode.querySelector('.find-in-store-panel__store-address').textContent = `${location.address1}, ${location.city} ${location.zip}`;
      templateNode.querySelector('.find-in-store-panel__store-info').innerHTML = `
        <a target="_blank" href="${this.storeInfoPage}" class="tw-text-primary_mid_grey tw-block tw-uppercase">Store info</a>
        <span class="tw-uppercase">&nbsp;</span>
      `;
      let stockStatus = templateNode.querySelector('.find-in-store-panel__stock-status');
      stockStatus.querySelectorAll('& > *').forEach(node => {
        node.classList.add('tw-hidden');
      });
      stockStatus.querySelectorAll(`[${location.stock > 0 ? 'in-stock' : 'sold-out'}]`).forEach(node => {
        node.classList.remove('tw-hidden');
      });

      storesList.appendChild(templateNode);
    });
  }

  getStockText(stock) {
    if (stock === undefined || stock === null) {
      return 'Stock information unavailable';
    }
    if (stock === 0) {
      return 'Out of stock';
    }
    if (stock < 5) {
      return `Only ${stock} ${stock === 1 ? 'item' : 'items'} available`;
    }
    return 'In stock';
  }

  escapeHtml(text) {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }
}

customElements.define('find-in-store-panel', FindInStorePanel);

